import LoanSummary from './loan-summary';

export default LoanSummary;
